import Tab from "components/Tab";
import MaskingInputWeb from "../../../../contents/docs/privacy/_snippets/autocapture-config-web.mdx";
import MaskingInputIos from "../../../../contents/docs/privacy/_snippets/autocapture-config-ios.mdx";
import MaskingInputReactNative from "../../../../contents/docs/privacy/_snippets/autocapture-config-react-native.mdx";
import * as React from 'react';
export default {
  Tab,
  MaskingInputWeb,
  MaskingInputIos,
  MaskingInputReactNative,
  React
};